// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#sale-report-f2-filters[data-v-0adfe42e]  .form-group{margin-bottom:2px}", ""]);
// Exports
module.exports = exports;
